import { UserActions } from "../reducers/user";

export const { userLogin, userLogout } = UserActions;
